import { AxiosResponse } from 'axios'
import { requests } from '.'
import servicesConfig, { CustomAxiosHeaders } from '../config/services'

const COMPANY = 'COMPANY'

const serviceName = 'ProspectingCommonService'
const host = servicesConfig.Prospecting as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const responseBody = (res: AxiosResponse) => res.data

class ProspectingCommonService {
  static getAgencySettings = async (companyId: string) => {
    try {
      if (!companyId || typeof companyId !== 'string') {
        return
      }
      return await request().get(`/settings/entities/${COMPANY}/${companyId}`).then(responseBody)
    } catch (error) {
      return
    }
  }
  static getLinkedSubAccountId = async (companyId: string, locationId: string) => {
    try {
      if (!companyId || typeof companyId !== 'string' || !locationId || typeof locationId !== 'string') {
        return
      }
      return await request().get(`/settings/link/entities/${companyId}/${locationId}`).then(responseBody)
    } catch (error) {
      return
    }
  }
}

export default ProspectingCommonService
